import React, { forwardRef } from 'react';

export const AppFooter = forwardRef((props, ref) => {
    const añoActual = new Date().getFullYear();
    const styles = {
        body: {
            color: '#6b7888',
        }
    };

    return (
        <div ref={ref} className="layout-footer">
            <img src="/clioydike.png" alt="Logo" height="20" className="mr" />
            <span className="font-medium ml-2" style={styles.body}>Ing. Jheyson Gaitan - © {añoActual} </span>
        </div>
    );
});